<div class="container" >
  <div class="d-flex justify-content-between" [ngClass]="componentClass">
    <div class="sec1 d-flex justify-content-between flex-wrap">
      <div *ngIf="firstclassLinks" class="d-flex justify-content-between flex-wrap">
        <div class="l" *ngFor="let link of firstclassLinks">
          <a class="d-flex align-items-center position-relative" [routerLink]="link.link"
            *ngIf="!link.external"
            [queryParams]="link.params || {}"
            >
            <span class="mr-1">{{ link.label}}</span>
            <div *ngIf="link.notifications > 0"
              class="nav-notifications d-flex align-items-center justify-content-center"> 
              {{ link.notifications }}
            </div>
            <span *ngIf="link.isNew" class="hot-icon">new</span>
            <span *ngIf="link.isHot" class="hot-icon">hot</span>
          </a>
          <!-- <a class="d-flex align-items-center position-relative" [routerLink]="[link.link]" [queryParams]="link.params"
            *ngIf="(!link.external) && link.params">
            <span class="mr-1">{{ link.label}}</span>
            <div *ngIf="link.notifications > 0" 
                class="nav-notifications d-flex align-items-center justify-content-center">
                {{ link.notifications }}
            </div>
            <span *ngIf="link.isNew" class="hot-icon">new</span>
            <span *ngIf="link.isHot" class="hot-icon">hot</span>
          </a> -->
          <a class="d-flex align-items-center position-relative" href="{{link.link}}" target="_blank"
            *ngIf="link.external">
            <span class="mr-1">{{ link.label}}</span>
            <div *ngIf="link.notifications > 0" 
              class="nav-notifications d-flex align-items-center justify-content-center">
              {{ link.notifications }}
            </div>
            <!-- <span *ngIf="link.isNew" class="new-item position-absolute"></span> -->
            <span *ngIf="link.isNew" class="hot-icon">new</span>
            <span *ngIf="link.isHot" class="hot-icon">hot</span>
          </a>
        </div>
        <!-- <div class="l empty" *ngFor="let item of emptyLinks"></div> -->
      </div>
    </div>
    <div class="separater separater1">
      <div class="line"></div>
    </div>
    <div class="sec2 adfav recommends d-flex justify-content-start width-inherit flex-wrap" *ngIf="isAdult">
      <div *ngFor="let item of adultFav">
        <a class="position-relative" [routerLink]="['/list']" [queryParams]="{tag: item.className}">{{ item.className }}
        </a>
      </div>
    </div>



    <div class="sec2 recommends d-flex justify-content-start flex-wrap"
      *ngIf="(!baseUrl && !isAdult ) || (!!baseUrl && !isAdult) || app">
      <div *ngFor="let item of recommends">
        <a class="position-relative d-flex align-items-center" [routerLink]="['/play',item.link]" >
          {{ item.title }}
          <div *ngIf="item.updateNumber > 0" class="new-videos d-flex align-items-center justify-content-center">{{ item.updateNumber }}</div> 
        </a>
      </div>
    </div>

    <div class="separater separater1">
      <div class="line"></div>
    </div>

    <ng-container *ngIf="CID === '0,1' && externalList.length > 0">
      <div class="sec3 d-flex justify-content-start">
        <div class="external-item d-flex align-items-center" *ngFor="let item of externalList | slice:0:5">
          <a class="d-flex flex-column align-items-center position-relative" href="{{ item.link }}" target="_blank" style="white-space: pre;">
            <div class="external-cover-box">
              <div class="cover-icon"></div>
              <img class="external-cover" *ngIf="!!item.image" [src]="item.image + '?w=36&h=36&mode=crop'" />
              <img class="external-cover" *ngIf="!item.image" src="{{ 'assets/images/default-album-cover.png?w=36&h=36&mode=crop' | absUrl }}" />
            </div>
            <div class="new-game-icon" *ngIf="item.isNew">NEW</div>
            {{ item.label }}
          </a>
        </div>
      </div>
      <div class="separater separater1">
        <div class="line"></div>
      </div>
    </ng-container>

    <div class="sec4 d-flex flex-wrap justify-content-end" [ngClass]="{'all-d':isAdult}">

      <div class="il" title="VIP中心">
        <a class="l vip-icon-hover" href="/vip-center/index" target="_blank">
          <span class="iconfont iconVIP"></span>
          <div>VIP</div>
        </a>
      </div>

      <div class="il" *ngIf="!hideAds" title="投放广告" >
        <a class="l" href="/ad-center/intro" target="_blank">
          <span class="iconfont iconguanggaotoufang"></span>
          <div>广告</div>
        </a>
      </div>
      <div class="il" title="下载APP" style="position: relative;" *ngIf="enableDownload">
        <a class="l" href="/app-download" target="_blank">
          <span class="iconfont iconxiazaiAPP"></span>
          <div>APP</div>
        </a>
        <!-- <div class="nav-new-icon">new</div> -->
      </div>
      <div class="il" title="午夜版" *ngIf="isNSFWMode">
        <a class="l" href="https://www.wyav.tv/" target="_blank" *ngIf="!isAdult && !shouldHideAdult">
          <span class="iconfont iconwuye2"></span>
          <div>午夜版</div>
        </a>
      </div>
    
    </div>
  </div>
</div>
